export enum TipologiaDecretoEnum {
    DECRETO_NON_CONTABILE = <any>"DECRETO_NON_CONTABILE",
    DECRETO_CONTABILE = <any>"DECRETO_CONTABILE",
    DECRETO_PROGRAMMAZIONE = <any>"DECRETO_PROGRAMMAZIONE"
}
